import { FC } from 'react';
import SelectFormutil, { OptionItem } from 'app/components/Formutil/SelectFormutil';
import { CustomerInfoKeyType, MaritalStatusEnum } from 'types/customer';
import { isEmptyValue } from 'utils/helper';
import { printf } from 'utils/i18n';

export interface MaritalStatusProps {
    disabled?: boolean;
}

export interface MaritalStatusFormutil {
    marital_status: MaritalStatusEnum;
}

export const defaultFieldsOfMaritalStatus: CustomerInfoKeyType[] = ['marital_status'];

const maritalStatusOptions: OptionItem[] = [
    { value: MaritalStatusEnum.SINGLE, label: __('Single') },
    { value: MaritalStatusEnum.MARRIED, label: __('Married') },
    { value: MaritalStatusEnum.DIVORCED, label: __('Divorced') },
    { value: MaritalStatusEnum.WIDOWED, label: __('Widowed') }
];
const MaritalStatus: FC<MaritalStatusProps> = ({ disabled }) => {
    return (
        <SelectFormutil
            name="marital_status"
            label={__('Marital Status')}
            checker={value => {
                if (disabled) {
                    return true;
                }

                if (isEmptyValue(value)) {
                    return printf(__('Please select your %s'), __('marital status'));
                }

                return true;
            }}
            selectProps={{
                options: maritalStatusOptions,
                placeholder: __('Marital Status'),
                disabled
            }}
        />
    );
};

export default MaritalStatus;
